var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.46 22.5921L44 26.9141L31.671 34.1351V43.0351L19.188 35.9001L11.808 40.1531V26.0901L4 21.5631L16.603 14.2231V5.58008L28.657 12.7141L36.459 8.32408L36.46 22.5921Z",
    fill: "url(#paint0_linear_1_1375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.603 19.5741V14.2241M16.603 14.2241V5.58008L28.656 12.7141M16.603 14.2241L4 21.5631L11.808 26.0911V40.1541L19.188 35.9011M24.068 24.1701L31.671 28.6981V19.8481M31.671 19.8481L31.67 14.4981L28.656 12.7141M31.671 19.8481L36.458 22.5921M11.81 26.0911V22.5921L24.07 15.4581V24.1701L16.604 28.6981L24.069 33.0881M24.069 33.0881L28.659 35.9011L31.672 34.1351M24.069 33.0881L19.19 35.9011M28.656 12.7141L36.459 8.32408L36.458 22.5921M36.458 22.5921L44 26.9141L31.671 34.1351V43.0351L19.188 35.9001",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1375",
    x1: 24,
    y1: 5.58008,
    x2: 24,
    y2: 43.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.300049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiency);
export default __webpack_public_path__ + "static/media/efficiency.7c1f7e6b221ec6e738e4e43a14090ea4.svg";
export { ForwardRef as ReactComponent };